import { render, staticRenderFns } from "./SiteEventsConfig.vue?vue&type=template&id=15bed784&"
import script from "./SiteEventsConfig.vue?vue&type=script&lang=js&"
export * from "./SiteEventsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports